module.exports = __webpack_public_path__ + "static/media/login_bg.82acc2fe.png";